import Handsontable from 'handsontable';
import { getCellPlaceholder } from './containerDispatchGrid';
import { formatAmountDisplay } from './numberUtils';

export const PLACEHOLDER_RENDERER = 'cdPlaceholder';
export const AMOUNT_RENDERER = 'cdAmount';

function cdPlaceholderRenderer(
  this: unknown,
  instance: Handsontable,
  td: HTMLTableCellElement,
  row: number,
  col: number,
  prop: string | number,
  value: unknown,
  cellProperties: Handsontable.CellProperties
) {
  Handsontable.renderers.TextRenderer.call(
    this,
    instance,
    td,
    row,
    col,
    prop,
    value,
    cellProperties
  );
  const meta = instance.getCellMeta(row, col) as { hidden?: boolean };
  if (meta.hidden) {
    td.textContent = '';
    return;
  }
  const text = value == null ? '' : String(value).trim();
  if (!text) {
    const hint = getCellPlaceholder(row, col);
    if (hint) {
      td.innerHTML = `<span class="cd-cell-hint">${hint}</span>`;
      return;
    }
  }
  td.style.color = '';
}

function cdAmountRenderer(
  this: unknown,
  instance: Handsontable,
  td: HTMLTableCellElement,
  row: number,
  col: number,
  prop: string | number,
  value: unknown,
  cellProperties: Handsontable.CellProperties
) {
  const display = formatAmountDisplay(value);
  Handsontable.renderers.TextRenderer.call(
    this,
    instance,
    td,
    row,
    col,
    prop,
    display,
    cellProperties
  );
  td.style.color = '';
}

// getRenderer는 미등록 시 예외를 던지므로, 항상 registerRenderer 호출
(Handsontable.renderers as unknown as {
  registerRenderer: (name: string, fn: typeof cdPlaceholderRenderer) => void;
}).registerRenderer(PLACEHOLDER_RENDERER, cdPlaceholderRenderer);
(Handsontable.renderers as unknown as {
  registerRenderer: (name: string, fn: typeof cdAmountRenderer) => void;
}).registerRenderer(AMOUNT_RENDERER, cdAmountRenderer);
